import { render, staticRenderFns } from "./PopUpTableWithDatatable.vue?vue&type=template&id=84dd700c"
import script from "./PopUpTableWithDatatable.vue?vue&type=script&lang=js"
export * from "./PopUpTableWithDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports